import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { RemmiConfirmService } from '@common/remmi-confirm/remmi-confirm.service';
import { automationImages } from '@images/automation-images';
import { commonImages } from '@images/common-images';
import { Pagination } from '@models/pagination.model';
import { ApiService } from '@services/api/api.service';
import { WorkflowService } from '@services/api/workflow.service';
import { AuthService } from '@services/auth.service';
import { Crypto } from '@services/helpers/encryption-utils';
import { LeadManagementService } from '@services/lm-service/lead-management.service';
import { ToastrService } from 'ngx-toastr';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-left-flow',
  templateUrl: './left-flow.component.html',
  styleUrls: ['./left-flow.component.scss'],
})
export class LeftFlowComponent implements OnInit, OnDestroy {
  @Output() triggerEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() LeftPanelExpanded: EventEmitter<boolean> = new EventEmitter<boolean>();

  TaskList: any = null;
  triggerEvents: any[] = [];
  trigger_original: any[] = [];
  images = automationImages;
  common_images = commonImages;

  public Pagination: Pagination;

  isNewTrigger: Boolean = false;
  searchStr: string = '';

  isRightBarExpanded: boolean = true;
  icon_array: any[] = [];

  show_icon: boolean = false;
  search_keyword: String = '';

  flow: any = null;
  trigger_id: any;

  workflow_type: 'workflow' | 'business_rules' = 'workflow';
  isLoading: boolean = false;
  isRightBarView: boolean = false;
  searchKeywordModule: any = null;
  public SortingMenu: any[] = [];
  sortMenuLabel: string = 'pi-sort-amount-down-alt';
  sort = 'new';
  constructor(
    private api: ApiService,
    private toast: ToastrService,
    public _workflowService: WorkflowService,
    private router: Router,
    public lmService: LeadManagementService,
    private Auth: AuthService,
    private remmiConfirm: RemmiConfirmService
  ) {
    this.SortingMenu = [
      { label: 'Alphabetical', command: () => this.DataSorting('atoz') },
      { label: 'Newest', command: () => this.DataSorting('new') },
      { label: 'Oldest', command: () => this.DataSorting('old') },
    ];
    this.icon_array = _workflowService.RemixIcons;
    this.flow = _workflowService.workFlowAutomation;
  }

  ngOnDestroy(): void {
    this.lmService.selected_workflow = null;
  }

  ngOnInit(): void {
    // Get all triggers and all workflows when component is initialized
    this.getTrigger();
    this.getFlow();

    // If route is not workflow/flow, set isRightBarView to true
    // and set selected_workflow to null
    if (this.router.url != '/setting/workflow/flow') {
      this.isRightBarView = true;
      this.lmService.selected_workflow = null;
    } else {
      // If route is workflow/flow, set selected_workflow to null
      this.lmService.selected_workflow = null;
    }

    // Listen to change office event and get triggers and workflows after 500ms
    this.Auth.getChangeUserOffice().subscribe({
      next: response => {
        if (response === 'change default office') {
          setTimeout(() => {
            this.getTrigger();
            this.getFlow();
          }, 500);
        }
      },
    });
  }

  isLoad: boolean = true;
  getFlow = (page = 1, per_page = 20, bool = false) => {
    let office_id = this.api.getOfficeId();
    this.api
      .get(
        `/workflow/get-all?office_id=${office_id}&page=${page}&per_page=${per_page}&type=${this.workflow_type}&keyword=${this.search_keyword}&module=${this.searchKeywordModule}&sort=${this.sort}`
      )
      .subscribe({
        next: response => {
          this.isPageLoading = true;
          this.isLoad = false;
          let triggerEvent = [];
          triggerEvent = this.trigger_original = response.data;
          this.Pagination = response?.meta?.pagination ? { ...response?.meta?.pagination } : null;
          if (bool) {
            this.triggerEvents.push(...triggerEvent);
            if (triggerEvent.length < 20) {
              this.isPageLoading = false;
              this.rows = this.triggerEvents.length;
            } else {
              this.rows += 20;
            }
          } else {
            this.page = 1;
            this.rows = 20;
            this.triggerEvents = triggerEvent;
            if (this.triggerEvents.length < 20) this.isPageLoading = false;
          }
        },
      });
  };

  changeIconHandler(icon: string) {
    // Update the display_icon and reset the show_icon and isSvg values
    this.display_icon = icon;
    this.show_icon = false;
    this.isSvg = icon.endsWith(`.svg`) ? true : false;
    // Update the isIcon label based on whether an icon has been selected or not
    if (icon) {
      return (this.isIcon = 'Icon Selected');
    }
    return (this.isIcon = 'Icon Selection');
  }

  // For trigger

  triggerDialog = false;
  display_icon;
  isSvg: boolean = false;
  updateTriggerId;
  isIcon;
  SpecificModuleListing: any[] = [];
  excludeModuleListing: any[] = [];
  ProjectsUnits: any = { selected: ([] = []), allunits: [] };

  triggerInfo = () => {
    const user_id = this.api.getUserId();
    const office_id = this.api.getOfficeId();
    let trigger = {
      parent: -1,
      id: uuidv4(),
      type: this.workflow_type,
      tigger_title: this.flow.title,
      children: [],
      isAction: null,
      office_id: office_id,
      created_by: user_id,
      icon: this.display_icon,
      module: this.flow.module,
      filter: this.flow.filter,
      readonlyfilter: this.flow.readonlyfilter,
      startoperationtime: {
        record_created: false,
        record_status_changes: false,
        record_assigned: false,
        record_fields_change: false,
        record_deleted: false,
      },
      trigger_id: '1',
      class: '',
      date: '',
      time: {
        days: '',
        hours: '',
      },
      user: {
        user_role: null,
        user: null,
      },
      tigger_desc: this.flow.desc,
      update_id: [],
      validation: [],
      notification: {
        notify_user: null,
        user: null,
        notify_from: null,
        sender: null,
        subject: '',
        message: '',
      },
      email: {
        email_to: null,
        user: null,
        subject: '',
        message: '',
      },
    };
    return trigger;
  };

  triggerEditPublish(formTrigger) {
    const user_id = this.api.getUserId();
    const office_id = this.api.getOfficeId();

    let trigger = {
      parent: -1,
      id: uuidv4(),
      type: this.workflow_type,
      tigger_title: this.flow.title,
      children: [],
      isAction: null,
      office_id: office_id,
      created_by: user_id,
      icon: this.display_icon,
      module: this.flow.module,
      filter: this.flow.filter,
      readonlyfilter: this.flow.readonlyfilter,
      projects: this.ProjectsUnits.selected,
      startoperationtime: this.flow.startoperationtime,
      trigger_id: '1',
      class: '',
      date: '',
      time: {
        days: '',
        hours: '',
      },
      user: {
        user_role: null,
        user: null,
      },
      tigger_desc: this.flow.desc,
      update_id: [],
      validation: [],
      notification: {
        notify_user: null,
        user: null,
        notify_from: null,
        sender: null,
        subject: '',
        message: '',
      },
      email: {
        email_to: null,
        user: null,
        subject: '',
        message: '',
      },
    };

    // Call API to update trigger
    this.api.put('/workflow/update/' + this.updateTriggerId, trigger).subscribe({
      next: response => {
        if (response['status'] === true) {
          formTrigger.resetForm({});
          this.SpecificModuleListing = this.ProjectsUnits.selected = this.ProjectsUnits.allunits = [];
          this.toast.success(response.message);
        }
        this.display_icon = '';
        this.updateTriggerId = '';
        this.getFlow();
      },
    });
  }

  cloneCopyTrigger(event, formTrigger: any) {
    event?.stopPropagation();
    if (formTrigger !== null) {
      // Call API to clone trigger
      this.api.post(`/workflow-duplicate`, { workflow_id: formTrigger?._id }).subscribe({
        next: response => {
          const { status } = response;
          if (status) {
            this.toast.success('Trigger cloned successfully');
            this.getTrigger();
            this.getFlow();
          }
        },
        error: _ => {
          this.toast.error('Something went wrong.');
        },
      });
    }
  }

  triggerPublish(
    event,
    formTrigger: {
      workflow_type: 'workflow' | 'business_rules';
      title: string;
      icon: string;
      module: string;
      filter: any[];
      readonlyfilter: string[];
      description: string;
      startoperationtime: any;
      projects?: any;
      can_start: any;
      children: any;
    } = null
  ) {
    event?.stopPropagation();
    var trigger = null;
    if (formTrigger !== undefined && formTrigger !== null && Object.keys(formTrigger)?.length > 0) {
      // when edit trigger and trigger is not null
      this.workflow_type = formTrigger?.workflow_type || 'workflow';
      this.flow.title = formTrigger?.title || '';
      this.display_icon = formTrigger?.icon || '';
      this.flow.module = formTrigger?.module || '';
      this.flow.filter = formTrigger?.filter || [];
      this.flow.readonlyfilter = formTrigger?.readonlyfilter || [];
      this.flow.desc = formTrigger?.description || '';
      this.flow.startoperationtime = formTrigger?.startoperationtime || null;
      this.ProjectsUnits.selected = formTrigger?.projects || null;
      this.flow.canStart = formTrigger?.can_start || null;
      trigger = this.triggerInfo();
      trigger = { ...trigger, children: formTrigger?.children || null };
    } else {
      // when add new trigger
      trigger = this.triggerInfo();
    }
    this.triggerDialog = false;
    trigger = {
      ...trigger,
      ...{
        tigger_title: this.flow.title,
        tigger_desc: this.flow.desc,
        icon: this.display_icon,
        module: this.flow.module,
        is_child_trigger: this.flow.is_child_trigger || false,
        exclude_records: this.flow.exclude_records || [],
        type: this.workflow_type,
        readonlyfilter: this.flow.readonlyfilter,
        filter: this.flow.filter,
        startoperationtime: this.flow.startoperationtime,
        canStart: this.flow.canStart,
        ...(this.flow.module == 'project_units' && { projects: this.ProjectsUnits?.selected }),
      },
    };
    this.api.post('/workflow/create', trigger).subscribe({
      next: _ => {
        this.getTrigger();
        this.getFlow();
      },
    });
  }

  confirmDeleteTrigger(action: any) {
    this.updateTriggerId = action?._id;
    this.remmiConfirm
      .delete({ title: 'Delete Trigger?', message: 'This trigger will be permanently deleted.', subject: action?.tigger_title })
      .subscribe(isConfirmed => isConfirmed && this.deleteTrigger());
  }

  deleteTrigger() {
    // delete trigger from backend
    this.api.delete('/workflow/delete/' + this.updateTriggerId).subscribe({
      next: response => {
        if (response['status'] === true) {
          this.toast.success('Workflow deleted successfully');
        }
        // reset dialog
        this.triggerDialog = false;
        this.display_icon = '';
        this.updateTriggerId = '';
        this.getFlow();
      },
    });
  }

  pinnedOrUnpinnedTrigger(action) {
    // toggle pinned status of trigger
    let trigger = {
      pinned: true,
    };
    trigger.pinned = action?.pinned ? !action?.pinned : true;

    // update trigger in backend
    this.api.put('/workflow/update/' + action._id, trigger).subscribe({
      next: _ => {
        this.display_icon = '';
        this.updateTriggerId = '';
        this.getFlow();
      },
    });
  }

  triggerNull() {
    // reset trigger info when click on new trigger button
    this.isIcon = 'Icon Selection';
    this.flow.title = null;
    this.flow.desc = null;
    this.flow.module = null;
    this.flow.startoperationtime = {
      record_created: false,
      record_status_changes: false,
      record_assigned: false,
      record_fields_change: false,
      record_deleted: false,
    };
    this.flow.created_at = null;
    this.flow.updated_at = null;
    this.display_icon = null;
    this.triggerDialog = true;
    this.isNewTrigger = true;
    this.updateTriggerId = null;
  }

  GetEditHeaderTitleForTrigger() {
    // this function is used to get the header title for trigger dialog
    // depending on whether we are creating new trigger or editing existing trigger
    return this.isNewTrigger ? 'Add a new trigger' : 'Edit trigger';
  }
  onChangeUnit = () => {
    // this code is used to set the filter values when we change the unit in create trigger or edit trigger
    this.flow['filter'] = [];
    if (this.isNewTrigger) {
      // when we create new trigger, we set the filter values as same as readonly filter
      this.flow.readonlyfilter.forEach(element => {
        this.flow['filter'].push({ _id: element, process: 'play' });
      });
    } else {
      // when we edit the trigger, we set the filter values as same as readonly filter
      let tempFilter: any[] = [];
      this.flow.readonlyfilter.forEach(element => {
        let filteredItem: any = this.flow['filter'].filter(res => res.id == element);
        if (filteredItem) {
          tempFilter.push({ _id: element, process: filteredItem?.process || 'play' });
        }
      });
      this.flow.filter = tempFilter;
    }
  };
  onChangeModule(value, eve = null) {
    if (value?.name !== 'Project Lots' || value?.name !== 'project_units') {
      this.flow.filter = this.flow.readonlyfilter = this.SpecificModuleListing = this.excludeModuleListing = [];
    }
    if (value?.name == 'Listing' || value?.name == 'properties') {
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetLisitingModuleListDetail().subscribe({
        next: response => {
          if (response?.['status']) {
            this.SpecificModuleListing = [...this.SpecificModuleListing, { _id: 'all', property_address: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?.property_address,
              process: 'play',
            }));
            this.SpecificModuleListing = this.SpecificModuleListing.filter(f => f.name !== undefined && f.name !== null);
            this.excludeModuleListing = [...this.excludeModuleListing, ...response?.data]?.map(result => ({
              ...result,
              name: result?.property_address,
              process: 'play',
            }));
            this.excludeModuleListing = this.excludeModuleListing.filter(f => f.name !== undefined && f.name !== null);
          }
        },
        error: _ => {
          this.SpecificModuleListing = [];
          this.excludeModuleListing = [];
        },
      });
    } else if (value?.name == 'Property' || value?.name == 'properties_data') {
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetPropertyModuleListDetail().subscribe({
        next: response => {
          if (response?.['status']) {
            this.SpecificModuleListing = [...this.SpecificModuleListing, { _id: 'all', property_address: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?.property_address,
              process: 'play',
            }));
            this.SpecificModuleListing = this.SpecificModuleListing.filter(f => f.name !== undefined && f.name !== null);
            this.excludeModuleListing = [...this.excludeModuleListing, ...response?.data]?.map(result => ({
              ...result,
              name: result?.property_address,
              process: 'play',
            }));
            this.excludeModuleListing = this.excludeModuleListing.filter(f => f.name !== undefined && f.name !== null);
          }
        },
        error: _ => {
          this.SpecificModuleListing = [];
          this.excludeModuleListing = [];
        },
      });
    } else if (value?.name == 'Projects' || value?.name == 'projects') {
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetProjectModuleListDetail().subscribe({
        next: response => {
          if (response?.['status']) {
            this.SpecificModuleListing = [...this.SpecificModuleListing, { _id: 'all', Project_Name: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?.Project_Name,
              process: 'play',
            }));
            this.excludeModuleListing = [...this.excludeModuleListing, ...response?.data]?.map(result => ({
              ...result,
              name: result?.Project_Name,
              process: 'play',
            }));
          }
        },
        error: _ => {
          this.SpecificModuleListing = [];
          this.excludeModuleListing = [];
        },
      });
    } else if (value?.name == 'Contact' || value?.name == 'contacts') {
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetContactModuleListDetail().subscribe({
        next: response => {
          if (response?.['status']) {
            this.SpecificModuleListing = [...this.SpecificModuleListing, { _id: 'all', full_name: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?.full_name,
              process: 'play',
            }));
            this.excludeModuleListing = [...this.excludeModuleListing, ...response?.data]?.map(result => ({
              ...result,
              name: result?.full_name,
              process: 'play',
            }));
          }
        },
        error: _ => {
          this.SpecificModuleListing = [];
          this.excludeModuleListing = [];
        },
      });
    } else if (value?.name == 'Tasks' || value?.name == 'tasks') {
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetTaskModuleListDetail().subscribe({
        next: response => {
          if (response?.['status']) {
            this.SpecificModuleListing = [...this.SpecificModuleListing, { _id: 'all', title: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?.title,
              process: 'play',
            }));
            this.excludeModuleListing = [...this.excludeModuleListing, ...response?.data]?.map(result => ({
              ...result,
              name: result?.title,
              process: 'play',
            }));
          }
        },
        error: _ => {
          this.SpecificModuleListing = [];
          this.excludeModuleListing = [];
        },
      });
    } else if (value?.name == 'Lead Management' || value?.name == 'lead_management') {
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetLeadManagementModuleListDetail().subscribe({
        next: response => {
          if (response?.['status']) {
            this.SpecificModuleListing = [...this.SpecificModuleListing, { _id: 'all', first_name: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?.first_name || '' + ' ' + result?.last_name || '',
              process: 'play',
            }));
            this.excludeModuleListing = [...this.excludeModuleListing, ...response?.data]?.map(result => ({
              ...result,
              name: result?.first_name || '' + ' ' + result?.last_name || '',
              process: 'play',
            }));
          }
        },
        error: _ => {
          this.SpecificModuleListing = [];
          this.excludeModuleListing = [];
        },
      });
    } else if (value?.name == 'Project Lots' || value?.name == 'project_units') {
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetProjectModuleListDetail().subscribe({
        next: response => {
          if (response?.['status']) {
            this.ProjectsUnits.allunits = [...[{ _id: 'all', Project_Name: 'All' }], ...response?.data]?.map(result => ({
              ...result,
              name: result?.Project_Name,
              process: 'play',
            }));
          }
        },
        error: _ => {
          this.ProjectsUnits.allunits = [];
          this.excludeModuleListing = [];
        },
      });
    } else if (value?.name == 'Specified Project Units') {
      if (eve && eve.itemValue === 'all' && this.ProjectsUnits?.selected.length !== this.ProjectsUnits?.allunits.length) {
        this.ProjectsUnits.selected = [];
        this.ProjectsUnits?.allunits.forEach(p => {
          if (p._id == eve.itemValue) {
            this.ProjectsUnits.selected.push(p._id);
          }
        });
      }
      this._workflowService.GetProjectUnitsModuleListDetail(this.ProjectsUnits?.selected).subscribe({
        next: response => {
          if (response?.['status']) {
            this.SpecificModuleListing = [...this.SpecificModuleListing, { _id: 'all', lot_name: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?._id == 'all' ? 'all' : result?.lot_name || '',
              process: 'play',
            }));
            this.excludeModuleListing = [...this.excludeModuleListing, ...response?.data]?.map(result => ({
              ...result,
              name: result?._id == 'all' ? 'all' : result?.lot_name || '',
              process: 'play',
            }));
          }
        },
        error: _ => {
          this.SpecificModuleListing = [];
          this.excludeModuleListing = [];
        },
      });
    } else if (value?.name == 'Contract' || value?.name == 'contract') {
      this.ProjectsUnits.allunits = [];
      this._workflowService.GetContractModuleListDetail().subscribe({
        next: response => {
          if (response?.['status']) {
            this.SpecificModuleListing = [...this.SpecificModuleListing, { _id: 'all', listing_name: 'All' }, ...response?.data]?.map(result => ({
              ...result,
              name: result?.listing_name,
              process: 'play',
            }));
            this.SpecificModuleListing = this.SpecificModuleListing.filter(f => f.name !== undefined && f.name !== null);
            this.excludeModuleListing = [...this.excludeModuleListing, ...response?.data]?.map(result => ({
              ...result,
              name: result?.listing_name,
              process: 'play',
            }));
            this.excludeModuleListing = this.excludeModuleListing.filter(f => f.name !== undefined && f.name !== null);
          }
        },
        error: _ => {
          this.SpecificModuleListing = [];
          this.excludeModuleListing = [];
        },
      });
    } else {
      this.SpecificModuleListing = [];
      this.excludeModuleListing = [];
    }
  }

  onChangeTriggerFilter() {
    this.triggerEvents = this.trigger_original;
    this.getFlow();
  }

  FilterSearchTaskList(): void {
    this.triggerEvents = this.trigger_original;
    this.getFlow();
  }

  onWorkflowChangeTab(status: 'workflow' | 'business_rules' = 'workflow') {
    // when tab change then update workflow type and get new trigger list
    if (this.workflow_type != status) {
      this.workflow_type = status;
      this._workflowService.TaskList = { ...this._workflowService.TaskList, type: this.workflow_type };
      this.getFlow();
    }
  }

  getTrigger() {
    let officeId = Crypto.decrypt(localStorage.getItem('officeid'));
    // get all trigger by office id
    this._workflowService.GetTriggerByOffices(officeId).subscribe({
      next: response => {
        this._workflowService.TaskList = { type: this.workflow_type, data: response?.data || [] };
        if (this.lmService.selected_workflow != null) {
          let selectedWOrkflow = null;
          if (this.lmService.selected_workflow?.is_readonly) {
            // if workflow is readonly show only readonly workflow
            selectedWOrkflow = [this.lmService.selected_workflow || {}];
            this.triggerEmitter.emit(selectedWOrkflow);
          } else {
            // if workflow is not readonly show all workflows
            selectedWOrkflow = response?.data.filter(f => f?._id == this.lmService.selected_workflow?._id);
            this.emitTriggerHandler(selectedWOrkflow?.[0]);
          }
        }
      },
    });
  }

  emitTriggerHandler = action => {
    //get detail of workflow
    this.api.get(`/workflow/get-by-id/${action._id}`).subscribe({
      next: res => {
        if (res.status) {
          let ele = [res.data];
          this.triggerEmitter.emit(ele);
        }
      },
    });
  };

  workflowPageChange(event) {
    // Timeout is used to prevent the function from being called multiple times when the user
    // changes the page size or page number.
    setTimeout(() => {
      let perPage = event.rows ? event.rows : 10;
      let pageNo = event.first / perPage + 1;
      this.getFlow(pageNo, perPage);
    }, 0);
  }

  DataSorting(type) {
    // toggle the sort order
    this.sort = type;
    this.getFlow();
    if (type == 'atoz') {
      // A to Z
      this.sortMenuLabel = 'pi-sort-alpha-down';
    } else if (type == 'old') {
      // Oldest first
      this.sortMenuLabel = 'pi-sort-amount-down';
    } else if (type == 'new') {
      // New set first
      this.sortMenuLabel = 'pi-sort-amount-down-alt';
    }
  }

  rows: number = 10;
  page: number = 1;
  isPageLoading: boolean = true;
  scrollTop: number = 0;
  @ViewChild('scrollableElement') scrollableElement!: ElementRef;
  scrollToTop(): void {
    // Scroll the content to the top of the scrollable element.
    // - Sets the scrollTop property of the element to 0.
    const element = this.scrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onScroll(event: Event): void {
    const element = event.target;
    this.scrollTop = element['scrollTop'];
    // Calculate remaining scroll height and current view port height
    let a: any = element['scrollHeight'] - element['scrollTop'];
    let b: any = element['scrollHeight'] - element['scrollTop'];
    let c = element['clientHeight'];

    // If within 5px of the bottom of the scrollable area and there are more results to fetch, fetch them
    if ((parseInt(a) - 5 < parseInt(c) || parseInt(b) == parseInt(c)) && this.isPageLoading) {
      this.page = this.page + 1;
      this.getFlow(this.page, 20, true);
    }
  }
}
